export const resolve_relations = "map_and_tile_section.locations"
